<template>
	<!-- App -->
  <div class="page rowBackgroundHomepage">

    <!-- Affichage sur petit écran -->
    <div class="showSmallScreenOnly">
      <f7-fab class="leftfav bottomButton floatingButtonToolbarBlank" href="/attachments/import/"
        :disabled="$engine.rights.rightIs('attachment_import', false)">
        <f7-icon f7="bullet_list"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav3 bottomButton floatingButtonToolbarBlank" href="/attachments/createInvoice/"
        :disabled="$engine.rights.rightIs('attachment_ajouter_facture', false)">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav3 bottomButton floatingButtonToolbarBlank" href="/attachments/createRefund/"
        :disabled="$engine.rights.rightIs('attachment_ajouter_order', false)">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV()">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>
    </div>

    <div class="page-content">
      <div class="layoutTop"></div>
      <!-- Affichage sur grand écran de bureau -->
      <div class="listPage">
        <b-row class="form-group justify-content-start showLargeScreenOnly">
          <b-col sm="2" class="showLargeScreenOnly">
            <f7-button class="button-action milkyBlockBlack"
              href="/attachments/import/"
              :disabled="$engine.rights.rightIs('attachment_import', false)">
              <f7-icon f7="bullet_list"></f7-icon>
              <span>{{ $t('common.imprt') }}</span>
            </f7-button>
          </b-col>
          <b-col sm="2" class="showLargeScreenOnly">
            <f7-button class="button-action milkyBlockBlack"
              href="/attachments/createInvoice/"
              :disabled="$engine.rights.rightIs('attachment_ajouter_facture', false)">
              <f7-icon f7="add"></f7-icon>
              <span>{{ $t('common.generate') }}</span>
            </f7-button>
          </b-col>
          <b-col sm="2">
            <f7-button class="button-action milkyBlockBlack" @click="extractCSV()">
              <f7-icon f7="document_text"></f7-icon>
              <span>{{ $t('common.extract') }}</span>
            </f7-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <f7-searchbar class="search filterTitle"
              search-list="#attachment-list"
              cancel-link="Cancel"
              :placeholder="attachmentsPage_SearchAttachments"
              clear-button virtual-init
              @searchbar:search="onSearch"
              @searchbar:clear="onClear">
            </f7-searchbar>
          </b-col>
        </b-row>

        <div class="itemList">
          <div class="layoutSubtitle"/>
          <attachments-list :service="service" :Attachments="Attachments"></attachments-list>
          <pagination
            :firstIndex="paginationObject.firstIndex"
            :maxResultsByPage="paginationObject.maxResults"
            :nbResultsTotal="paginationObject.nbResultsTotal"
            :refreshEvent="paginationObject.refresh">
          </pagination>
        </div>
        <div class="toolbarPageBottomBlank"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import attachmentFilter from '@/components/common/CMAttachmentFilter.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import pagination from '@/components/common/pagination.vue'

import attachmentsList from './CMAttachmentsPage/CMAttachmentsList.vue'

import documentSerialize from '@/helpers/documentSerialize.json'
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'Attachments',
  components: {
    'attachments-list': attachmentsList,
    'attachment-filter': attachmentFilter,
    'pagination': pagination,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      isSmartphone: false,
      Attachments: [],
      attachmentsSelected: [],
      filterBy: '',
      service: '',
      paginationObject: {}
    }
  },
  created () {
    this.attachmentsPage_AttachmentsList = this.$i18n.t('attachments.attachments_list')
    this.attachmentsPage_SearchAttachments = this.$i18n.t('attachments.search_attchmnts')
    let that = this
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'refresh-cache-attachments-paging'
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage

    this.$bus.$off('refresh-cache-attachments-paging')
    this.$bus.$on('refresh-cache-attachments-paging', (index) => {
      that.getAttachmentsPagination(index)
    })
    this.service = this.$engine.user.currentService.name
    this.getAttachmentsPagination()

    // TODO: event taphold
    that.$$(document).on('taphold', '.attachmentTaphold', function () {
      if (that.attachmentsSelected.includes(that.$$(this).data('item')) === false) {
        that.attachmentsSelected.push(that.$$(this).data('item'))
        that.$$(this).addClass('listItemSelected')
      } else if (that.attachmentsSelected.includes(that.$$(this).data('item')) === true) {
        let index = that.attachmentsSelected.indexOf(that.$$(this).data('item'))
        if (index > -1) {
          that.attachmentsSelected.splice(index, 1)
        }
        that.$$(this).removeClass('listItemSelected')
      }
    })
  },
  methods: {
    onSearch (query, found) {
      this.filterBy = query
      this.getAttachmentsPagination()
    },
    getLabelType (type) {
      if (type === '0') {
        return this.$i18n.t('attachments.invce')
      } else if (type === '1') {
        return this.$i18n.t('attachments.refnd')
      } else {
        return this.$i18n.t(documentSerialize[type].label)
      }
    },
    orderAttachments (response) {
      var attachmentList = {}
      let cloudFiles = response.data.docs
      let nbElement = 0
      this.paginationObject.nbResults = 0
      for (var j = 0; j < cloudFiles.length; j++) {
        var firstLetter = cloudFiles[j].name.substr(0, 1).toUpperCase()
        var type = this.getLabelType(cloudFiles[j].type)
        if (cloudFiles[j].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
          nbElement++
          if (this.paginationObject.firstIndex <= nbElement && nbElement < (this.paginationObject.firstIndex + this.paginationObject.maxResults)) {
            if (!attachmentList.hasOwnProperty(firstLetter)) {
              attachmentList[firstLetter] = []
            }
            this.paginationObject.nbResults++
            attachmentList[firstLetter].push({name: cloudFiles[j].name, type: type, id: cloudFiles[j].id})
            attachmentList[firstLetter].sort()
          }
        }
      }
      this.paginationObject.nbResultsTotal = nbElement
      return this.orderKeys(attachmentList)
    },
    getAttachmentsPagination (index = 1) {
      let that = this
      this.paginationObject.firstIndex = index

      let params = {
        idAcct: this.$engine.user.get().id
        // 'firstIndex': this.paginationObject.firstIndex,
        // 'maxResults': this.paginationObject.maxResults
      }

      // smartphoneStorage vaut true si on est sur petit écran, false sinon
      if (this.$engine.services.directPayments.filter.smartphoneStorage) {
        this.isSmartphone = true
      }
      that.$engine.attachments.getRefresh(params).then(response => {
        this.Attachments = this.orderAttachments(response)
        // this.$bus.on => src/components/common/pagination.vue
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    onClear () {
      this.filterBy = ''
    },
    orderKeys (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    extractCSV () {
      let that = this
      let params = {
        idAcct: this.$engine.user.get().id
      }

      // smartphoneStorage vaut true si on est sur petit écran, false sinon
      if (this.$engine.services.directPayments.filter.smartphoneStorage) {
        this.isSmartphone = true
      }
      that.$engine.attachments.getRefresh(params).then(response => {
        let cloudFiles = response.data.docs
        let firstLine = 'id;name;type\r\n'
        let lines = ''
        for (var k in cloudFiles) {
          // if (cloudFiles[k].name.toLowerCase().includes(that.filterBy.toLowerCase()) &&
          // ((this.service === 'Payments' && cloudFiles[k].type[0] === '0') ||
          // (this.service === 'Direct Payments' && cloudFiles[k].type[0] === '1') ||
          // this.service === 'Direct Debit')) {
          if (cloudFiles[k].name.toLowerCase().includes(that.filterBy.toLowerCase())) {
            lines += cloudFiles[k].id + ';' + cloudFiles[k].name + ';' + this.getLabelType(cloudFiles[k].type) + '\r\n'
          }
        }

        let data = firstLine + lines

        let linkSource = 'data:text/csv;charset=utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        var fileName = ''
        // if (this.service === 'Direct Debit') {
        //   fileName = 'attachmentModularLoan' + today.unix() + '.csv'
        // } else if (this.service === 'Direct Payments') {
        //   fileName = 'attachmentDirectPayments' + today.unix() + '.csv'
        // } else {
        //   fileName = 'attachmentRequestToPay' + today.unix() + '.csv'
        // }
        fileName = 'attachment' + today.unix() + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    createDrafts () {
      let that = this
      let attachmentList = that.$engine.attachments.get()
      let defaultCreditorBankAccount = ''
      if (this.$engine.bankAccounts.getDefaultBankAccount().iban !== undefined) {
        defaultCreditorBankAccount = that.$engine.bankAccounts.getDefaultBankAccount().iban
      }
      let defaultNegotiationAllowedValue = this.$engine.settings.get().defaultNegotiationAllowed === '1'
      let draftArray = []
      for (let i = 0; i < attachmentList.length; i++) {
        if (that.attachmentsSelected.includes(attachmentList[i].id)) {
          draftArray.push({
            'idAccount': this.$engine.user.get().id,
            'CreditorBankAccount': defaultCreditorBankAccount,
            'CreditorIdentifier': this.$engine.user.get().identifier,
            'DebtorName': attachmentList[i].debtorName,
            'DebtorBankAccount': attachmentList[i].debtorBankAccount,
            'DebtorIdentifier': attachmentList[i].debtorEmail,
            'RemittanceInformation': attachmentList[i].remittanceInformation,
            'ImmPmtAccepted': 'false',
            'PymtNtr': 'TERM',
            'RequestedExecutionDate': attachmentList[i].paymentsDate,
            'Amount': attachmentList[i].amount,
            'ModificationAccepted': defaultNegotiationAllowedValue,
            'AttachmentId': attachmentList[i].id,
            'AttachmentName': attachmentList[i].name,
            'AttachmentReference': attachmentList[i].internalReference
          })
        }
      }
      let requestLoad = {
        'drafts': draftArray
      }
      that.$engine.drafts.create(requestLoad)
      .then(response => {
        if (response.status === 200) {
          this.$f7.modal({
            title: 'Drafts added',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.Dom7('.attachmentTaphold').removeClass('listItemSelected')
            that.attachmentsSelected = []
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .search {
    margin-top: 42px;
  }
  .toolbarPageBottomBlank {
    height: 175px !important;
  }
}

@media (min-width: 768px) and (max-width: 996px) {
  .search {
    margin-top: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// CMAttachmentsPage.vue?50b31059